module.exports = __webpack_public_path__ + "img/Logo-small-trans.4dac702e.png";